import { REVIEW_STATES, TReviewStates } from '@/constants';

const reviewStatesValueToLabel = (
  value: number,
  reviewStateOptions: TReviewStates[] = REVIEW_STATES
) => {
  return reviewStateOptions.find(state => state.value === value)?.label;
};

export { reviewStatesValueToLabel };
